import {
  CityIcon,
  EarthIcon,
  type IconProps,
  InfinityOutlineIcon,
  LockOutlineIcon,
  ResponsiveOutlineIcon,
  WidthAndHeightOutlineIcon,
} from '@carboncopyco/icons';
import { ShareSecurityLevel } from '@carboncopyco/types';
import type { IShareDropdownItem } from './ShareDropdownMenu';

export const DEFAULT_EXPIRATION_PERIOD = 7;

export const accessIcons = {
  restricted: LockOutlineIcon,
  internal: InfinityOutlineIcon,
  email_domain: CityIcon,
  anyone: EarthIcon,
};

export const accessDescription = {
  restricted: 'Restricted emails list allowed for viewing',
  internal: 'Restricted for internal visitors only',
  email_domain: 'Only visitors from a pre-defined org domain can view',
  anyone: 'Anyone with the link can view it',
};

export type AccessLevel = ShareSecurityLevel;
export type SecurityItem = {
  id: ShareSecurityLevel;
  label: string;
  description: string;
  icon: (props: IconProps) => React.ReactElement;
  disabled?: boolean;
};

export function getAccessLevels(
  emailDomain = ''
): Record<AccessLevel, SecurityItem> {
  return {
    internal: {
      label: 'Internal',
      id: ShareSecurityLevel.internal,
      icon: accessIcons.internal,
      description: `Only visitors with ${emailDomain} email can view`,
    },
    restricted: {
      label: 'Restricted',
      id: ShareSecurityLevel.restricted,
      icon: accessIcons.restricted,
      description: 'Only visitors with a pre-defined email address can view',
    },
    email_domain: {
      label: 'Email domain',
      id: ShareSecurityLevel['emailDomain'],
      icon: accessIcons.email_domain,
      description: 'Only visitors from a pre-defined org domain can view',
    },
    anyone: {
      label: 'Anyone',
      id: ShareSecurityLevel.anyone,
      icon: accessIcons.anyone,
      description: 'Anyone with this link can view',
    },
  };
}

export const tourAspectRatioItems: IShareDropdownItem[] = [
  {
    id: 'responsive',
    label: 'Responsive',
    description:
      'Make the width & height of the tour elements change based on then viewer’s screen size',
    icon: <ResponsiveOutlineIcon />,
  },
  {
    id: 'fixedWidthAndHeight',
    label: 'Fixed width and height',
    description:
      'Keep the width & height of tour elements the same across all screen sizes according to capturing ratio',
    icon: <WidthAndHeightOutlineIcon />,
  },
];
